import type { ComponentProps } from "react";
import { useIntl, defineMessages } from "react-intl";

import { DeprecatedTextField } from "common/form/fields/text";

const MESSAGES = defineMessages({
  placeholder: {
    id: "517bcf2c-ad40-4dcb-84ba-4ec5870832ff",
    defaultMessage: "Email address",
  },
  label: {
    id: "222a36da-3a37-4f40-a3bb-1e61f50eaa3b",
    defaultMessage: "Email address",
  },
});

/** @deprecated - please use components in common/core/form */
export function DeprecatedEmailField(
  props: Omit<ComponentProps<typeof DeprecatedTextField>, "aria-label">,
) {
  const intl = useIntl();
  return (
    <DeprecatedTextField
      placeholder={props.placeholder || intl.formatMessage(MESSAGES.placeholder)}
      aria-label={intl.formatMessage(MESSAGES.label)}
      {...props}
    />
  );
}

DeprecatedEmailField.defaultProps = {
  id: "email",
  type: "email",
  "data-automation-id": "email-field",
  autoComplete: "email",
};
